module.exports = __webpack_public_path__ + "assets/img/bbcfaac9d8ea794daca5f3a4aab7b3e2.svg";